import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context/context";
import { useEffect, useState } from "react";
import DeletePopUP from "../../../CommonPopUp/DeletePopUp";
import UpdatePopup from "../../../CommonPopUp/UpdatePopup";
import { YearDDL } from "../../../CommonDDL/YearDDL";
import { MonthDDL } from "../../../CommonDDL/MonthDDL";
import { PlantationDetailsPartFirstPostAPI, PlantationDetailsPartFirstTableDataAPI } from "../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFirstSlice";
import { Loading } from "../../../../Helper/LogoLoader/LogoLoader";
import { UnitNameDDL } from "../../../CommonDDL/UnitNameDDL";
import PlantingTypeViewPopUp from "./PlantingTypeViewPopUp/PlantingTypeViewPopUp";


const PartFirstPopup = (props) => {

    const { handleShowAddModal, ShowAddModal, YearValue, MonthValue, Title } = props
    const { flag, data } = ShowAddModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID, IndicatorGrievanceAreaID } = userDetails

    const [UpdateViewPopup, setUpdateViewPopup] = useState(false)
    const [DeleteViewPopup, setDeleteViewPopup] = useState(false)
    const [GridData, setGridData] = useState([])
    const [RowIndex, setRowIndex] = useState()
    const [IsDataPost, setIsDataPost] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [UnitID, setUnitID] = useState('0')
    const [UnitName, setUnitName] = useState('')
    // const [TotalLandArea, setTotalLandArea] = useState(flag == 'Update' ? GridData[index].area : '0')

    const [PartFirstTextField, setPartFirstTextField] = useState({
        Year: '',
        Month: '',
        NoOfPlantReceived: '',
        NoOfPlantPlanted: '',
        NoOfPlantSurvived: '',
        NoOfPlantkeptAtHome: '',
        NoofPlantDiedatHome: '',
    })

    const [Year, setYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [MonthDDLID, setMonthDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const handleShowUpdate = (index) => {
        setRowIndex(index)
        setUpdateViewPopup(!UpdateViewPopup)
    }

    const handleShowDelete = () => {
        setDeleteViewPopup(!DeleteViewPopup)
    }

    const [ShowViewModal, setShowViewModal] = useState({
        showHide: false,
        // flag: '',
        data: ''
    })

    const handleShowViewModal = (show, data, flag) => {
        setShowViewModal({
            showHide: show,
            data: '',
            // flag: flag,
        })
    }

    useEffect(() => {
        // console.log("flag", GridData && GridData[0].m_UnitID)

        GridData && GridData.length > 0 && GridData.map((i, index) => {

            // console.log(GridData && GridData[index]?.m_UnitID)
            setUnitID(flag == 'Update' ? GridData && GridData[index]?.m_UnitID : '0')
            setUnitName(flag == 'Update' ? GridData && GridData[index]?.m_Unit : '')

        })


    }, [GridData])

    const onChange = (index, e) => {
        const { name, value } = e.target;
        var data = [...GridData];
        let x = JSON.parse(JSON.stringify(data));
        x[index][name] = value;
        setGridData(x)
        // console.log("result", data[index]["financialYearID"] = value)
        // console.log("data", x)

    };


    const handleGetFormData = (result) => {

        if (result && result.length > 0) {
            setGridData(result)
        } else {
            setGridData([])
        }

    }

    const handleIsDataPost = () => {
        setIsDataPost(!IsDataPost)
        setUpdateViewPopup(false)
    }

    useEffect(() => {
        const data = {
            FinancialYearID: Year.ID,
            MonthsID: MonthDDLID.ID,
            T_BeneficiaryWisePlantation_FinancialYearDetailsID: ShowAddModal.data.t_BeneficiaryWisePlantation_FinancialYearDetailsID,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            token: token,
            handleGetFormData: handleGetFormData
        }

        dispatch(PlantationDetailsPartFirstTableDataAPI({ data }))

    }, [IsDataPost, IsClear, Year.ID, MonthDDLID.ID])

    const { isFirstPartLoading, tableData } = useSelector(state => state.PlantationDetailsPartFirstTableData)

    const handleSubmit = () => {

        const data = {
            T_BeneficiaryWisePlantation_MonthDetailsID: GridData[RowIndex].t_BeneficiaryWisePlantation_MonthDetailsID,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            T_BeneficiaryWisePlantation_FinancialYearDetailsID: GridData[RowIndex].t_BeneficiaryWisePlantation_FinancialYearDetailsID,
            T_BeneficiaryWisePlotsDetailsID: 0,
            MonthsID: GridData[RowIndex].monthsID,
            No_of_PlantsReceived: GridData[RowIndex].no_of_PlantsReceived,
            No_of_PlantsPlanted: GridData[RowIndex].no_of_PlantsPlanted,
            No_of_PlantsSurvived: GridData[RowIndex].no_of_PlantsSurvived,
            No_of_Plants_kept_at_home: GridData[RowIndex].no_of_Plants_kept_at_home,
            No_of_Plants_Died_at_home: GridData[RowIndex].no_of_Plants_Died_at_home,
            Area: GridData[RowIndex].area,
            M_UnitID: UnitID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsDataPost

        }
        dispatch(PlantationDetailsPartFirstPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.PlantationDetailsPartFirstPostData)

    const handleClear = () => {
        console.log('dgfdg')
        setIsClear(!IsClear)
        setYear({
            ...Year,
            ID: 0,
            Label: "Select...",
        })
        setMonthDDLID({
            ...MonthDDLID,
            ID: 0,
            Label: "Select...",
        })

    }


    return (
        <>

            <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                {isFirstPartLoading && <Loading />}
                <div className="modal-dialog modal-xl " style={{ minWidth: '80vw' }} role="document"  >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                            <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ overflowY: 'scroll', height: '70vh' }}>
                            <div className="row">
                                <div className="row mb-4 px-2">

                                    <div className="col-xl-3 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2">
                                        <YearDDL
                                            Year={Year}
                                            setYear={setYear}
                                            apiFlag=''
                                            Flag=''
                                            data=''
                                            IsPost=''
                                        />

                                    </div>

                                    <div className="col-xl-3 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2">
                                        <MonthDDL
                                            MonthDDLID={MonthDDLID}
                                            setMonthDDLID={setMonthDDLID}
                                            apiFlag=''
                                            Flag=''
                                            data=''
                                            IsPost=''
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 pt-2 mt-3 mt-lg-3 pt-lg-4  pb-3 pb-lg-0 align-items-end ">
                                        {/* <button type="button" className="btn btn-outline-dark border-2 mx-2 "
                                        // onClick={handleSearch}
                                        >
                                            Search</button> */}


                                        <button type="button" className="btn btn-danger border-2"
                                            onClick={handleClear}
                                        >Clear</button>

                                    </div>
                                </div>

                                {/* <TableData /> */}

                                <div className="table-responsive p-0" >
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="bg-gradient-dark text-white">
                                                <th className="" style={{ width: '5%' }}>Sr. No.</th>
                                                <th className="text-center" style={{ width: '10%' }}>Year</th>
                                                <th className="text-center" style={{ width: '10%' }}>Month</th>
                                                <th className="text-center" style={{ width: '10%' }}>No of plant<br />Received</th>
                                                <th className="text-center" style={{ width: '10%' }}>No of plant<br />Planted</th>
                                                <th className="text-center" style={{ width: '10%' }}>No of Plant<br />Survived</th>
                                                <th className="text-center" style={{ width: '10%' }}>No of Plant<br />kept at Home</th>
                                                <th className="text-center" style={{ width: '10%' }}>No of plant<br />died at Home</th>
                                                <th className="text-center" style={{ width: '20%' }}>Area / Unit </th>
                                                <th className="text-center" style={{ width: '20%' }}>Planting Type </th>
                                                <th className="">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                GridData && GridData.length > 0 ? GridData.map((i, index) => {
                                                    return (

                                                        <tr>
                                                            <td align="center">{index + 1}</td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="financialYearID"
                                                                    // id="financialYearID"                                              
                                                                    placeholder={GridData[index].financialYearID}
                                                                    onChange={(e) => onChange(index, e)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="monthsName"
                                                                    placeholder={GridData[index].monthsName}
                                                                    onChange={(e) => onChange(index, e)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="no_of_PlantsReceived"
                                                                    placeholder={GridData[index].no_of_PlantsReceived}
                                                                    onChange={(e) => onChange(index, e)}


                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="no_of_PlantsPlanted"
                                                                    placeholder={GridData[index].no_of_PlantsPlanted}
                                                                    onChange={(e) => onChange(index, e)}


                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="no_of_PlantsSurvived"
                                                                    placeholder={GridData[index].no_of_PlantsSurvived}
                                                                    onChange={(e) => onChange(index, e)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="no_of_Plants_kept_at_home"
                                                                    placeholder={GridData[index].no_of_Plants_kept_at_home}
                                                                    onChange={(e) => onChange(index, e)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mx-auto"
                                                                    name="no_of_Plants_Died_at_home"
                                                                    placeholder={GridData[index].no_of_Plants_Died_at_home}
                                                                    onChange={(e) => onChange(index, e)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <div className="col-12">
                                                                    <div className="col-12">
                                                                        <div className="input-group ">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="area"
                                                                                placeholder={GridData[index].area}
                                                                                onChange={(e) => onChange(index, e)}

                                                                            />

                                                                            <span className="input-group-text">
                                                                                <UnitNameDDL
                                                                                    UnitID={UnitID}
                                                                                    setUnitID={setUnitID}
                                                                                    UnitName={UnitName}
                                                                                    setUnitName={setUnitName}
                                                                                    apiFlag='Master'
                                                                                    Flag={flag}
                                                                                    // data={GridData && GridData[index]}
                                                                                    IsPost=''

                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </td>
                                                            <td align="center">
                                                                <span>

                                                                    <i className="fa-solid fa-eye mx-2 v_icon_style" title="Edit"
                                                                        onClick={() => {
                                                                            handleShowViewModal(true)
                                                                        }}
                                                                    ></i>
                                                                </span>
                                                            </td>
                                                            <td align="center">
                                                                <i className="fa fa-edit mx-2 v_icon_style" title="Edit"
                                                                    onClick={() => handleShowUpdate(index)}
                                                                ></i>
                                                                <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                    // onClick={() => handleShowDelete(i)}
                                                                    title="Do you want to delete this record?"
                                                                    onClick={() => handleShowDelete()}
                                                                ></i>
                                                            </td>
                                                            {/* <td align="center">
                                                                        <span className="view_button px-3 py-1"
                                                                            onClick={() => handleShowAddModal(true, 'Update', i, 'BeneficiaryDetails ')}
                                                                        >
                                                                            View
                                                                        </span>
                                                                        <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                            onClick={() => handleShowDelete(i)}
                                                                            title="Do you want to delete this record?"></i>


                                                                    </td> */}

                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <>No data found</>
                                            }


                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            {
                DeleteViewPopup &&
                <DeletePopUP
                    handleShowDelete={handleShowDelete}
                // Title='Delete'
                // ModalData={ModalData}

                />
            }

            {
                UpdateViewPopup &&
                <UpdatePopup
                    handleSubmit={handleSubmit}
                    handleShowUpdate={handleShowUpdate}
                    Title='Update'
                    Message='Are you sure! Do you want to Update ?'

                // ModalData={ModalData}

                />
            }
            {
                ShowViewModal.showHide &&
                <PlantingTypeViewPopUp
                    handleShowViewModal={handleShowViewModal}
                    ShowViewModal={ShowViewModal}
                    T_BeneficiaryWisePlantation_FinancialYearDetailsID={ShowAddModal.data.t_BeneficiaryWisePlantation_FinancialYearDetailsID}
                    M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                />
            }

        </>);
}

export default PartFirstPopup;